import { FormikErrors, FormikValues } from 'formik';
import { formatDate, formatPhoneValue, GenericObject } from '@fnol/library/src/lib';
import { constValues, legalPersonType } from './consts';

export const scrollToFirstError = (errors: FormikErrors<GenericObject>) => {
    const errorKeys = Object.keys(errors);

    if (errorKeys.length > 0) {
        const firstElement = document.querySelector(`[name=${errorKeys[0]}]`) as HTMLElement;

        const getTopOffset = (el: HTMLElement): number => {
            const labelOffset = 150;
            return el?.getBoundingClientRect().top + window.scrollY - labelOffset;
        };

        window.scroll({
            top: getTopOffset(firstElement),
            left: 0,
            behavior: 'smooth',
        });
    }
};

export const prepareRolesList = (
    roles: { id: number; naziv: string; prikaziFL: boolean; prikaziPL: boolean; prefilPodataka: boolean }[] = [],
) => {
    return roles.map((role) => {
        return {
            id: role.id,
            value: role.naziv,
            individual: role.prikaziFL,
            legalEntity: role.prikaziPL,
            prefilData: role.prefilPodataka,
        };
    });
};

export const prepareRisksList = (risks: { id: number; naziv: string; opis: string }[] = []) => {
    return risks.map((risk) => {
        return {
            id: risk.id,
            value: risk.naziv,
            opis: risk.opis,
        };
    });
};

export const prepareCitiesList = (cities: { id: number; naziv: string; sifra: string; postanskiBroj: string }[]) => {
    return cities.map((city) => {
        return {
            id: city.id,
            value: `${city.id}/${city.naziv}`,
            label: city.naziv,
            zipCode: city.postanskiBroj,
            code: city.sifra,
        };
    });
};

/**
 * Prepare Formik data for submit
 *
 * @param values - object containing Formik state
 * @returns dataForSubmit - object with mapped data for submit
 */

export const prepareDataForSubmit = (values: FormikValues) => {
    const dataForSubmit: GenericObject = {};
    dataForSubmit.brojPolise = values.policyNumber;
    dataForSubmit.jmbg = values.policyUCN;
    dataForSubmit.datumNastanka = formatDate(values.dateOfOccurrence);
    dataForSubmit.podnosilacVrstaLica = values.submitterType;
    dataForSubmit.rizikId = values.risk.id;

    if (values.submitterType === legalPersonType.individual) {
        dataForSubmit.podnosilacFL = {
            svojstvoLicaId: values.submitterIndividualPersonRole.id,
            ime: values.submitterIndividualName,
            prezime: values.submitterIndividualLastName,
            drzavaId: values.submitterIndividualCountry,
            jmbg:
                values.submitterIndividualCountry == constValues.countrySerbiaId
                    ? values.submitterIndividualUCN
                    : '1111111111111',
            ulica: values.submitterIndividualStreet.label
                ? values.submitterIndividualStreet.label
                : values.submitterIndividualStreet,
            ulicaBroj: values.submitterIndividualStreetNumber,
            mobilniTelefon: formatPhoneValue(values.submitterIndividualPhone),
            email: values.submitterIndividualEmail,
        };
        if (values.submitterIndividualDateOfBirth) {
            dataForSubmit.podnosilacFL.datumRodjenja = formatDate(values.submitterIndividualDateOfBirth);
        }
        if (
            values.submitterIndividualCountry !== constValues.countrySerbiaId.toString(10) &&
            values.submitterIndividualCountry !== constValues.countrySerbiaId
        ) {
            dataForSubmit.podnosilacFL.mesto = values.submitterIndividualCity;
        } else {
            dataForSubmit.podnosilacFL.mestoId = values.submitterIndividualCityInSerbia.id;
            dataForSubmit.podnosilacFL.mesto = values.submitterIndividualCityInSerbia.label;
        }
    } else {
        dataForSubmit.podnosilacPL = {
            svojstvoLicaId: values.submitterLegalEntityPersonRole.id,
            naziv: values.submitterLegalEntityName,
            drzavaId: values.submitterLegalEntityCountry,
            ulica: values.submitterLegalEntityStreet.label
                ? values.submitterLegalEntityStreet.label
                : values.submitterLegalEntityStreet,
            ulicaBroj: values.submitterLegalEntityStreetNumber,
            maticniBroj: values.submitterLegalEntityID,
            pib: values.submitterLegalEntityVAT,
            email: values.submitterLegalEntityEmail,
            kontaktIme: values.submitterLegalEntityContactName,
            kontaktPrezime: values.submitterLegalEntityContactLastName,
            kontaktMobilniTelefon: formatPhoneValue(values.submitterLegalEntityContactPhone),
            kontaktEmail: values.submitterLegalEntityContactEmail,
        };
        if (
            values.submitterLegalEntityCountry !== constValues.countrySerbiaId.toString(10) &&
            values.submitterLegalEntityCountry !== constValues.countrySerbiaId
        ) {
            dataForSubmit.podnosilacPL.mesto = values.submitterLegalEntityCity;
        } else {
            dataForSubmit.podnosilacPL.mestoId = values.submitterLegalEntityCityInSerbia.id;
            dataForSubmit.podnosilacPL.mesto = values.submitterLegalEntityCityInSerbia.label;
        }
    }

    return dataForSubmit;
};
